// exportVoucherToExcel.ts
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'

export interface VoucherExportRow {
    voucherTypeName: string
    voucherName: string
    voucherNameEn: string
    total: number
    status: string
    updatedBy: string
    updatedAt: string  // YYYY-MM-DD HH:mm:ss
}

export interface VoucherExportReport {
    title: string      // e.g. 'จัดการ Gift Voucher'
    statusFilter: string      // e.g. 'ทั้งหมด'
    rows: VoucherExportRow[],
    t: any
}

export async function exportVoucherToExcel(rpt: VoucherExportReport) {
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(rpt.title)

    // ตั้งความสูง row default
    ws.properties.defaultRowHeight = 18

    // 1) คอลัมน์ A–G
    ws.columns = [
        { header: rpt.t('TABLE.NO'), width: 6 },
        { header: rpt.t('VOUCHER.TABLE.VOUCHER_TYPENAME'), width: 20 },
        { header: rpt.t('VOUCHER.TABLE.VOUCHER_NAME'), width: 30 },
        { header: rpt.t('VOUCHER.TABLE.VOUCHER_NAMEEN'), width: 30 },
        { header: rpt.t('VOUCHER.TABLE.UNIT'), width: 10 },
        { header: rpt.t('VOUCHER.TABLE.VOUCHER_STATUS'), width: 15 },
        { header: rpt.t('VOUCHER.TABLE.UPDATED_BY'), width: 30 }
    ]

    let row = 1

    // 2) Title (A1–G1)
    ws.mergeCells(row, 1, row, ws.columns.length)
    const cellTitle = ws.getCell(row, 1)
    cellTitle.value = rpt.title
    cellTitle.font = { size: 16, bold: true }
    cellTitle.alignment = { horizontal: 'center', vertical: 'middle' }
    row++

    // 3) สถานะ filter (A2–G2)
    ws.mergeCells(row, 1, row, ws.columns.length)
    const cellFilter = ws.getCell(row, 1)
    cellFilter.value = `สถานะ: ${rpt.statusFilter}`
    cellFilter.font = { size: 12 }
    cellFilter.alignment = { horizontal: 'left', vertical: 'middle' }
    row += 2

    // 4) Header row (แถว 3 หรือ row)
    const headerRow = ws.addRow(ws.columns.map(c => (c.header as string)))
    headerRow.font = { bold: true }
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
    headerRow.height = 20
    headerRow.eachCell(cell => {
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    })
    row++

    if (!rpt.rows || rpt.rows.length === 0) {
        const noDataRow = ws.addRow([rpt.t('REPORT.TITLE.NO_DATA')])
        ws.mergeCells(noDataRow.number, 1, noDataRow.number, ws.columns.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
        const buf = await wb.xlsx.writeBuffer()
        saveAs(
            new Blob([buf]),
            `${rpt.title}_${moment().format('YYYYMMDD')}.xlsx`
        )
        return
    }

    // 5) Data rows
    rpt.rows.forEach((d, i) => {
        const r = ws.addRow([
            i + 1,
            d.voucherTypeName,
            d.voucherName,
            d.voucherNameEn,
            d.total,
            d.status,
            `${d.updatedBy} ${d.updatedAt}`
        ])
        r.alignment = { vertical: 'middle' }
        r.eachCell((cell, col) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            switch (col) {
                case 2:
                case 3:
                case 4:
                    cell.alignment = { horizontal: 'left', vertical: 'middle' }
                    break
                default:
                    cell.alignment = { horizontal: 'center', vertical: 'middle' }
            }
        })
    })

    // 6) Save
    const buf = await wb.xlsx.writeBuffer()
    saveAs(
        new Blob([buf]),
        `${rpt.title}_${moment().format('YYYYMMDD')}.xlsx`
    )
}
